"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.add_3 = add_3;
exports.angle = angle;
exports.angle_3 = angle_3;
exports.assignTHREEMatrix4FromMatrix4 = assignTHREEMatrix4FromMatrix4;
exports.atan2 = atan2;
exports.bboxBboxIntersect = bboxBboxIntersect;
exports.bboxBboxIntersect_3 = bboxBboxIntersect_3;
exports.bboxUnion = bboxUnion;
exports.bboxUnion_3 = bboxUnion_3;
exports.cross = cross;
exports.cross_3 = cross_3;
exports.dot = dot;
exports.dot_3 = dot_3;
exports.getMatrix2D = getMatrix2D;
exports.getMatrix2DFromMatrix3 = getMatrix2DFromMatrix3;
exports.getMatrix3FromMatrix4 = getMatrix3FromMatrix4;
exports.getMatrix4FromTHREEMatrix4 = getMatrix4FromTHREEMatrix4;
exports.invertMatrix3 = invertMatrix3;
exports.isBboxDefined = isBboxDefined;
exports.isInBbox = isInBbox;
exports.isInBbox_3 = isInBbox_3;
exports.max = max;
exports.max_3 = max_3;
exports.min = min;
exports.min_3 = min_3;
exports.mul = mul;
exports.mul_3 = mul_3;
exports.multiplyMatrix2DMatrix2D = multiplyMatrix2DMatrix2D;
exports.multiplyMatrix2DPoint = multiplyMatrix2DPoint;
exports.multiplyMatrix3Matrix3 = multiplyMatrix3Matrix3;
exports.multiplyMatrix3Point = multiplyMatrix3Point;
exports.multiplyMatrix4Matrix4 = multiplyMatrix4Matrix4;
exports.multiplyMatrix4Point = multiplyMatrix4Point;
exports.norm = norm;
exports.norm2 = norm2;
exports.norm2_3 = norm2_3;
exports.norm_3 = norm_3;
exports.normalize = normalize;
exports.normalize_3 = normalize_3;
exports.sub = sub;
exports.sub_3 = sub_3;
/** A 2-dimensional point or vector */

/** A 3-dimensional point or vector */

/** A 2-dimensional bounding box */

/** A 3-dimensional bounding box */

/** A 3x3 matrix representing a transformation in 2 dimensions */

/** A 3x3 matrix representing a 3-dimensional rotation */

/** A 4x4 matrix representing a 3-dimensional rotation followed by a translation */

/**
 * Computes the dot product of two vectors
 * @param {Vector} a The first vector
 * @param {Vector} b The second vector
 * @returns {number} The dot product
 */
function dot(a, b) {
  return a.x * b.x + a.y * b.y;
}

/**
 * Computes the dot product of two 3-dimensional vectors
 * @param {Vector3} a The first vector
 * @param {Vector3} b The second vector
 * @returns {number} The dot product
 */
function dot_3(a, b) {
  return a.x * b.x + a.y * b.y + a.z * b.z;
}

/**
 * Adds several vectors
 * @param {...Vector} vecs The vectors
 * @returns {Vector} The sum of the vectors
 */
function add(...vecs) {
  return {
    x: vecs.reduce((a, c) => a + c.x, 0),
    y: vecs.reduce((a, c) => a + c.y, 0)
  };
}

/**
 * Adds several 3-dimensional vectors
 * @param {...Vector3} vecs The vectors
 * @returns {Vector3} The sum of the vectors
 */
function add_3(...vecs) {
  return {
    x: vecs.reduce((a, c) => a + c.x, 0),
    y: vecs.reduce((a, c) => a + c.y, 0),
    z: vecs.reduce((a, c) => a + c.z, 0)
  };
}

/**
 * Subtracts two vectors
 * @param {Vector} a The first vector
 * @param {Vector} b The second vector
 * @returns {Vector} The difference, a - b, of the two vectors
 */
function sub(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}

/**
 * Subtracts two 3-dimensional or vectors
 * @param {Vector3} a The first vector
 * @param {Vector3} b The second vector
 * @returns {Vector3} The difference, a - b, of the two vectors
 */
function sub_3(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y,
    z: a.z - b.z
  };
}

/**
 * Multiples vector `a` by scalar `b`
 * @param {Vector} a
 * @param {number} b 
 * @returns {Vector}
 */
function mul(a, b) {
  return {
    x: a.x * b,
    y: a.y * b
  };
}

/**
 * Multiples 3-dimensinal vector `a` by scalar `b`
 * @param {Vector3} a
 * @param {number} b
 * @returns {Vector3}
 */
function mul_3(a, b) {
  return {
    x: a.x * b,
    y: a.y * b,
    z: a.z * b
  };
}

/**
 * Computes the length of a vector
 * @param {Vector} a The vector
 * @returns {number} The length (norm) of the vector
 */
function norm(a) {
  return Math.sqrt(norm2(a));
}

/**
 * Computes the length of a 3-dimensional vector
 * @param {Vector3} a The vector
 * @returns {number} The length (norm) of the vector
 */
function norm_3(a) {
  return Math.sqrt(norm2_3(a));
}

/**
 * Computes the squared length of a vector
 * @param {Vector} a The vector
 * @returns {number} The squared length of the vector
 */
function norm2(a) {
  return dot(a, a);
}

/**
 * Computes the squared length of a 3-dimensional vector
 * @param {Vector3} a The vector
 * @returns {number} The squared length of the vector
 */
function norm2_3(a) {
  return dot_3(a, a);
}

/**
 * Computes a normalized vector. The original vector is not changed.
 * @param {Vector} a
 * @returns {Vector} The normalized vector.
 */
function normalize(a) {
  let n = norm(a);
  return mul(a, 1 / n);
}

/**
 * Computes a normalized 3-dimensinal vector. The original vector is not changed.
 * @param {Vector3} a
 * @returns {Vector3} The normalized vector.
 */
function normalize_3(a) {
  let n = norm_3(a);
  return mul_3(a, 1 / n);
}

/**
 * Computes the cross product of two vectors.
 * @param {Vector} a The first vector
 * @param {Vector} b The second vector
 * @returns {number} The cross product of the two vectors, as a number.
 */
function cross(a, b) {
  return a.x * b.y - a.y * b.x;
}

/**
 * Computes the cross product of two 3-dimensional vectors.
 * @param {Vector3} a The first vector
 * @param {Vector3} b The second vector
 * @returns {Vector3} The cross product of the two vectors.
 */
function cross_3(a, b) {
  return {
    x: a.y * b.z - a.z * b.y,
    y: a.z * b.x - a.x * b.z,
    z: a.x * b.y - a.y * b.x
  };
}

/**
 * Returns a vector whose x and y components are the maximum values of the x and y components of the input vectors. Null and
 * undefined vectors are ignored.
 * @param vecs
 * @returns The vector whose x and y components are the maximum values of the x and y components of the input vectors.
 */

function max(...vecs) {
  var _vecs$reduce;
  return (_vecs$reduce = vecs.reduce((a, c) => c == null ? a : a == null ? c : {
    x: Math.max(a.x, c.x),
    y: Math.max(a.y, c.y)
  }, null)) !== null && _vecs$reduce !== void 0 ? _vecs$reduce : null;
}

/**
 * Returns a vector whose x, y, and z components are the maximum values of the x, y, and z components of the input vectors. Null and
 * undefined vectors are ignored.
 * @param vecs
 * @returns The vector whose x, y, and z components are the maximum values of the x, y, and z components of the input vectors.
 */

function max_3(...vecs) {
  var _vecs$reduce2;
  return (_vecs$reduce2 = vecs.reduce((a, c) => c == null ? a : a == null ? c : {
    x: Math.max(a.x, c.x),
    y: Math.max(a.y, c.y),
    z: Math.max(a.z, c.z)
  }, null)) !== null && _vecs$reduce2 !== void 0 ? _vecs$reduce2 : null;
}

/**
 * Returns a vector whose x and y components are the minimum values of the x and y components of the input vectors. Null and
 * undefined vectors are ignored.
 * @param vecs
 * @returns The vector whose x and y components are the minimum values of the x and y components of the input vectors.
 */

function min(...vecs) {
  var _vecs$reduce3;
  return (_vecs$reduce3 = vecs.reduce((a, c) => c == null ? a : a == null ? c : {
    x: Math.min(a.x, c.x),
    y: Math.min(a.y, c.y)
  }, null)) !== null && _vecs$reduce3 !== void 0 ? _vecs$reduce3 : null;
}

/**
 * Returns a vector whose x, y, and z components are the minimum values of the x, y, and z components of the input vectors. Null and
 * undefined vectors are ignored.
 * @param vecs
 * @returns The vector whose x, y, and z components are the minimum values of the x, y, and z components of the input vectors.
 */

function min_3(...vecs) {
  var _vecs$reduce4;
  return (_vecs$reduce4 = vecs.reduce((a, c) => c == null ? a : a == null ? c : {
    x: Math.min(a.x, c.x),
    y: Math.min(a.y, c.y),
    z: Math.min(a.z, c.z)
  }, null)) !== null && _vecs$reduce4 !== void 0 ? _vecs$reduce4 : null;
}

/**
 * Returns a bounding box formed from the union of the input bounding boxes.
 * @param  {...BoundingBox} bboxs
 * @returns {BoundingBox}
 */
function bboxUnion(...bboxs) {
  let bboxMin = min(...bboxs.map(b => b.min));
  let bboxMax = max(...bboxs.map(b => b.max));
  if (bboxMin && bboxMax) {
    return {
      min: bboxMin,
      max: bboxMax
    };
  }
  return null;
}

/**
 * Returns a 3-dimensional bounding box formed from the union of the input bounding boxes.
 * @param  {...BoundingBox3} bboxs
 * @returns {BoundingBox3}
 */
function bboxUnion_3(...bboxs) {
  let bboxMin = min_3(...bboxs.map(b => b.min));
  let bboxMax = max_3(...bboxs.map(b => b.max));
  if (bboxMin && bboxMax) {
    return {
      min: bboxMin,
      max: bboxMax
    };
  }
  return null;
}

/**
 * Tests whether the given vector is inside the given bounding box.
 * @param {Vector} p Vector
 * @param {BoundingBox} bbox The bounding box
 * @param {boolean} includeEdge Whether to include the edge as part of the bounding box. Default=true
 * @returns {boolean}
 */
function isInBbox(p, bbox, includeEdge = true) {
  return includeEdge && p.x >= bbox.min.x && p.x <= bbox.max.x && p.y >= bbox.min.y && p.y <= bbox.max.y || !includeEdge && p.x > bbox.min.x && p.x < bbox.max.x && p.y > bbox.min.y && p.y < bbox.max.y;
}

/**
 * Tests whether the given 3-dimensional vector is inside the given 3-dimensional bounding box.
 * @param {Vector3} p Vector
 * @param {BoundingBox3} bbox The bounding box
 * @param {boolean} includeEdge Whether to include the edge as part of the bounding box. Default=true
 * @returns {boolean}
 */
function isInBbox_3(p, bbox, includeEdge = true) {
  return includeEdge && p.x >= bbox.min.x && p.x <= bbox.max.x && p.y >= bbox.min.y && p.y <= bbox.max.y && p.z >= bbox.min.z && p.z <= bbox.max.z || !includeEdge && p.x > bbox.min.x && p.x < bbox.max.x && p.y > bbox.min.y && p.y < bbox.max.y && p.z > bbox.min.z && p.z < bbox.max.z;
}

/**
 * Returns the angle from the origin to the vector p, equal to Math.atan2(p.y, p.x)
 * @param {Vector} p
 * @returns {number}
 */
function atan2(p) {
  return Math.atan2(p.y, p.x);
}

/**
 * Returns the angle between two vectors
 * @param {Vector} a
 * @param {Vector} b
 * @returns {number}
 */
function angle(a, b) {
  let a_dot_b = dot(a, b);
  let mag_a = norm(a);
  let mag_b = norm(b);
  let norm_term = mag_a * mag_b;
  if (norm_term > 0.00001) {
    let acos_arg = a_dot_b / norm_term;
    acos_arg = Math.min(Math.max(acos_arg, -1), 1);
    return Math.acos(acos_arg);
  }
  return 0;
}

/**
 * Returns the angle between two 3-dimensional vectors
 * @param {Vector3} a 
 * @param {Vector3} b 
 * @returns {number}
 */
function angle_3(a, b) {
  let a_dot_b = dot_3(a, b);
  let mag_a = norm_3(a);
  let mag_b = norm_3(b);
  let norm_term = mag_a * mag_b;
  if (norm_term > 0.00001) {
    let acos_arg = a_dot_b / norm_term;
    acos_arg = Math.min(Math.max(acos_arg, -1), 1);
    return Math.acos(acos_arg);
  }
  return 0;
}

/**
 * Tests whether two bounding boxes intersect
 * @param {BoundingBox} bbox1 The first bounding box
 * @param {BoundingBox} bbox2 The second bounding box
 * @param {boolean} includeEdge Whether to include the edge as part of the bounding box. Default = true
 * @returns {boolean} Whether the two boxes intersect
 */
function bboxBboxIntersect(bbox1, bbox2, includeEdge = true) {
  if (includeEdge) {
    return bbox1.max.x >= bbox2.min.x && bbox1.min.x <= bbox2.max.x && bbox1.max.y >= bbox2.min.y && bbox1.min.y <= bbox2.max.y;
  } else {
    return bbox1.max.x > bbox2.min.x && bbox1.min.x < bbox2.max.x && bbox1.max.y > bbox2.min.y && bbox1.min.y < bbox2.max.y;
  }
}

/**
 * Tests whether two 3-dimensional bounding boxes intersect
 * @param {BoundingBox3} bbox1 The first bounding box
 * @param {BoundingBox3} bbox2 The second bounding box
 * @param {boolean} includeEdge Whether to include the edge as part of the bounding box. Default = true
 * @returns {boolean} Whether the two boxes intersect
 */
function bboxBboxIntersect_3(bbox1, bbox2, includeEdge = true) {
  if (includeEdge) {
    return bbox1.max.x >= bbox2.min.x && bbox1.min.x <= bbox2.max.x && bbox1.max.y >= bbox2.min.y && bbox1.min.y <= bbox2.max.y && bbox1.max.z >= bbox2.min.z && bbox1.min.z <= bbox2.max.z;
  } else {
    return bbox1.max.x > bbox2.min.x && bbox1.min.x < bbox2.max.x && bbox1.max.y > bbox2.min.y && bbox1.min.y < bbox2.max.y && bbox1.max.z > bbox2.min.z && bbox1.min.z < bbox2.max.z;
  }
}

/**
 * Tests a bounding box to see if it is fully defined. Acts as a type guard for BoundingBox.
 * @param bbox The bounding box to be tested
 * @returns Whether the bounding box is fully defined.
 */
function isBboxDefined(bbox) {
  return !!bbox && bbox.min != null && bbox.max != null;
}

/**
 * Multiplies two transform matrices
 * @param mat1 The left matrix
 * @param mat2 the right matrix
 * @returns The product of the two matrices
 */
function multiplyMatrix2DMatrix2D(mat1, mat2) {
  return [[mat1[0][0] * mat2[0][0] + mat1[0][1] * mat2[1][0] + mat1[0][2] * mat2[2][0], mat1[0][0] * mat2[0][1] + mat1[0][1] * mat2[1][1] + mat1[0][2] * mat2[2][1], mat1[0][0] * mat2[0][2] + mat1[0][1] * mat2[1][2] + mat1[0][2] * mat2[2][2]], [mat1[1][0] * mat2[0][0] + mat1[1][1] * mat2[1][0] + mat1[1][2] * mat2[2][0], mat1[1][0] * mat2[0][1] + mat1[1][1] * mat2[1][1] + mat1[1][2] * mat2[2][1], mat1[1][0] * mat2[0][2] + mat1[1][1] * mat2[1][2] + mat1[1][2] * mat2[2][2]], [mat1[2][0] * mat2[0][0] + mat1[2][1] * mat2[1][0] + mat1[2][2] * mat2[2][0], mat1[2][0] * mat2[0][1] + mat1[2][1] * mat2[1][1] + mat1[2][2] * mat2[2][1], mat1[2][0] * mat2[0][2] + mat1[2][1] * mat2[1][2] + mat1[2][2] * mat2[2][2]]];
}

/**
 * Multiplies two transform matrices
 * @param mat1 The left matrix
 * @param mat2 the right matrix
 * @returns The product of the two matrices
 */
function multiplyMatrix3Matrix3(mat1, mat2) {
  return multiplyMatrix2DMatrix2D(mat1, mat2);
}

/**
 * Multiplies two transform matrices
 * @param mat1 The left matrix
 * @param mat2 the right matrix
 * @returns The product of the two matrices
 */
function multiplyMatrix4Matrix4(mat1, mat2) {
  return [[mat1[0][0] * mat2[0][0] + mat1[0][1] * mat2[1][0] + mat1[0][2] * mat2[2][0] + mat1[0][3] * mat2[3][0], mat1[0][0] * mat2[0][1] + mat1[0][1] * mat2[1][1] + mat1[0][2] * mat2[2][1] + mat1[0][3] * mat2[3][1], mat1[0][0] * mat2[0][2] + mat1[0][1] * mat2[1][2] + mat1[0][2] * mat2[2][2] + mat1[0][3] * mat2[3][2], mat1[0][0] * mat2[0][3] + mat1[0][1] * mat2[1][3] + mat1[0][2] * mat2[2][3] + mat1[0][3] * mat2[3][3]], [mat1[1][0] * mat2[0][0] + mat1[1][1] * mat2[1][0] + mat1[1][2] * mat2[2][0] + mat1[1][3] * mat2[3][0], mat1[1][0] * mat2[0][1] + mat1[1][1] * mat2[1][1] + mat1[1][2] * mat2[2][1] + mat1[1][3] * mat2[3][1], mat1[1][0] * mat2[0][2] + mat1[1][1] * mat2[1][2] + mat1[1][2] * mat2[2][2] + mat1[1][3] * mat2[3][2], mat1[1][0] * mat2[0][3] + mat1[1][1] * mat2[1][3] + mat1[1][2] * mat2[2][3] + mat1[1][3] * mat2[3][3]], [mat1[2][0] * mat2[0][0] + mat1[2][1] * mat2[1][0] + mat1[2][2] * mat2[2][0] + mat1[2][3] * mat2[3][0], mat1[2][0] * mat2[0][1] + mat1[2][1] * mat2[1][1] + mat1[2][2] * mat2[2][1] + mat1[2][3] * mat2[3][1], mat1[2][0] * mat2[0][2] + mat1[2][1] * mat2[1][2] + mat1[2][2] * mat2[2][2] + mat1[2][3] * mat2[3][2], mat1[2][0] * mat2[0][3] + mat1[2][1] * mat2[1][3] + mat1[2][2] * mat2[2][3] + mat1[2][3] * mat2[3][3]], [mat1[3][0] * mat2[0][0] + mat1[3][1] * mat2[1][0] + mat1[3][2] * mat2[2][0] + mat1[3][3] * mat2[3][0], mat1[3][0] * mat2[0][1] + mat1[3][1] * mat2[1][1] + mat1[3][2] * mat2[2][1] + mat1[3][3] * mat2[3][1], mat1[3][0] * mat2[0][2] + mat1[3][1] * mat2[1][2] + mat1[3][2] * mat2[2][2] + mat1[3][3] * mat2[3][2], mat1[3][0] * mat2[0][3] + mat1[3][1] * mat2[1][3] + mat1[3][2] * mat2[2][3] + mat1[3][3] * mat2[3][3]]];
}

/**
 * Multiplies a transform matrix and a point
 * @param {Matrix2D} mat 
 * @param {Vector} point
 * @returns {Vector}
 */
function multiplyMatrix2DPoint(mat, point) {
  return {
    x: mat[0][0] * point.x + mat[0][1] * point.y + mat[0][2],
    y: mat[1][0] * point.x + mat[1][1] * point.y + mat[1][2]
  };
}

/**
 * For a given position and rotation, returns a 2D transform matrix
 * @param {Vector} position
 * @param {number} rotation
 * @returns {Matrix2D}
 */
function getMatrix2D(position, rotation) {
  let cos = Math.cos(rotation);
  let sin = Math.sin(rotation);
  return [[cos, -sin, position.x], [sin, cos, position.y], [0, 0, 1]];
}

/**
 * Extracts the rotation portion of a Matrix4 and returns it as a Matrix3
 * @param matrix The matrix to extract the rotation from
 * @returns The rotation matrix
 */
function getMatrix3FromMatrix4(matrix) {
  return [[matrix[0][0], matrix[0][1], matrix[0][2]], [matrix[1][0], matrix[1][1], matrix[1][2]], [matrix[2][0], matrix[2][1], matrix[2][2]]];
}

/**
 * Extracts the rotation portion of a Matrix3 and returns it as a Matrix2D
 * @param matrix The matrix to extract the rotation from
 * @returns The rotation matrix
 */
function getMatrix2DFromMatrix3(matrix) {
  return [[matrix[0][0], matrix[0][1], 0], [matrix[1][0], matrix[1][1], 0], [0, 0, 1]];
}

/**
 * Returns an oshlib Matrix4 from a three.js Matrix4.
 * @param matrix The three.js Matrix4 to convert
 * @returns The converted matrix
 */
function getMatrix4FromTHREEMatrix4(matrix) {
  // elements are in column-major order
  return [[matrix.elements[0], matrix.elements[4], matrix.elements[8], matrix.elements[12]], [matrix.elements[1], matrix.elements[5], matrix.elements[9], matrix.elements[13]], [matrix.elements[2], matrix.elements[6], matrix.elements[10], matrix.elements[14]], [matrix.elements[3], matrix.elements[7], matrix.elements[11], matrix.elements[15]]];
}
function assignTHREEMatrix4FromMatrix4(threeMatrix, matrix) {
  // set takes elements in row-major order
  threeMatrix.set(matrix[0][0], matrix[0][1], matrix[0][2], matrix[0][3], matrix[1][0], matrix[1][1], matrix[1][2], matrix[1][3], matrix[2][0], matrix[2][1], matrix[2][2], matrix[2][3], matrix[3][0], matrix[3][1], matrix[3][2], matrix[3][3]);
}

/**
 * Returns the inverse of a 3x3 matrix.
 * @param matrix The matrix to invert
 * @returns The inverted matrix
 */
function invertMatrix3(matrix) {
  let det = matrix[0][0] * matrix[1][1] * matrix[2][2] + matrix[0][1] * matrix[1][2] * matrix[2][0] + matrix[0][2] * matrix[1][0] * matrix[2][1] - matrix[0][2] * matrix[1][1] * matrix[2][0] - matrix[0][1] * matrix[1][0] * matrix[2][2] - matrix[0][0] * matrix[1][2] * matrix[2][1];
  // Just return infinities if det is 0
  let invdet = 1 / det;
  return [[(matrix[1][1] * matrix[2][2] - matrix[1][2] * matrix[2][1]) * invdet, (matrix[0][2] * matrix[2][1] - matrix[0][1] * matrix[2][2]) * invdet, (matrix[0][1] * matrix[1][2] - matrix[0][2] * matrix[1][1]) * invdet], [(matrix[1][2] * matrix[2][0] - matrix[1][0] * matrix[2][2]) * invdet, (matrix[0][0] * matrix[2][2] - matrix[0][2] * matrix[2][0]) * invdet, (matrix[0][2] * matrix[1][0] - matrix[0][0] * matrix[1][2]) * invdet], [(matrix[1][0] * matrix[2][1] - matrix[1][1] * matrix[2][0]) * invdet, (matrix[0][1] * matrix[2][0] - matrix[0][0] * matrix[2][1]) * invdet, (matrix[0][0] * matrix[1][1] - matrix[0][1] * matrix[1][0]) * invdet]];
}
function multiplyMatrix3Point(matrix, point) {
  return {
    x: matrix[0][0] * point.x + matrix[0][1] * point.y + matrix[0][2] * point.z,
    y: matrix[1][0] * point.x + matrix[1][1] * point.y + matrix[1][2] * point.z,
    z: matrix[2][0] * point.x + matrix[2][1] * point.y + matrix[2][2] * point.z
  };
}
function multiplyMatrix4Point(matrix, vector) {
  return {
    x: matrix[0][0] * vector.x + matrix[0][1] * vector.y + matrix[0][2] * vector.z + matrix[0][3],
    y: matrix[1][0] * vector.x + matrix[1][1] * vector.y + matrix[1][2] * vector.z + matrix[1][3],
    z: matrix[2][0] * vector.x + matrix[2][1] * vector.y + matrix[2][2] * vector.z + matrix[2][3]
  };
}